export const MASTER_PART_NO_NOT_FOUND_MESSAGE = 'No Part found';
export const MASTER_PART_NO_OBSOLETE_MESSAGE = 'Part No is obsolete. Please change the Part No.';
export const MASTER_PART_NO_VALIDATION_ERROR_MESSAGE = 'Unable to validate Part No. Check the connection and try again.';

export const MASTER_PART_NO_VALIDATION_STATUS = {
    IDLE: 'idle',
    CHECKING: 'checking',
    VALID: 'valid',
    INVALID: 'invalid',
    ERROR: 'error',
};

export function normalizeMasterPartNo(value) {
    if (value === null || value === undefined) return '';
    return String(value).trim().toUpperCase();
}

export function getPartDataRows(body) {
    if (!body) return [];
    if (Array.isArray(body)) return body;
    if (Array.isArray(body.data)) return body.data;
    if (body.part) return [body.part];
    return [];
}

export function getMatchingPartDataRow(rows, partNo) {
    const target = normalizeMasterPartNo(partNo);
    if (!target) return null;

    return getPartDataRows(rows).find((row) => {
        const fullPartNo = normalizeMasterPartNo(row && row.fullPartNo);
        const fallbackPartNo = normalizeMasterPartNo(row && row.partNo);
        return fullPartNo === target || fallbackPartNo === target;
    }) || null;
}

export function hasMatchingFullPartNo(rows, partNo) {
    return !!getMatchingPartDataRow(rows, partNo);
}

export function buildMasterPartNoLookupUrl(apiUrl, company, partNo) {
    const baseUrl = String(apiUrl || '').replace(/\/+$/, '');
    const params = new URLSearchParams({
        company: String(company || ''),
        partNo: String(partNo || '').trim(),
    });

    return `${baseUrl}/getNewPartCreationExists?${params.toString()}`;
}

export async function checkFullPartNoExists({ apiUrl, company, partNo, fetchFn }) {
    const normalizedPartNo = normalizeMasterPartNo(partNo);
    if (!normalizedPartNo) {
        return { exists: false, part: null, fullPartNo: '' };
    }
    if (!apiUrl || !company) {
        throw new Error(MASTER_PART_NO_VALIDATION_ERROR_MESSAGE);
    }

    const request = fetchFn || fetch;
    const response = await request(buildMasterPartNoLookupUrl(apiUrl, company, normalizedPartNo), {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' },
    });

    if (!response || !response.ok) {
        throw new Error(MASTER_PART_NO_VALIDATION_ERROR_MESSAGE);
    }

    const text = await response.text();
    const body = text ? JSON.parse(text) : null;
    const match = getMatchingPartDataRow(body, normalizedPartNo);
    const exists = !!(body && body.exists) || !!match;
    const part = match || (body && body.part) || null;
    const fullPartNo = part ? (part.fullPartNo || part.partNo || '') : '';
    const customerPartNo = part ? (part.customerPartNo || '') : '';
    const isObsolete = !!(part && (part.isObsolete === true || part.isObsolete === 1 || part.isObsolete === '1'));

    return { exists, part, fullPartNo, customerPartNo, isObsolete };
}

export function isPartNoCreateEnabled(status) {
    return status === MASTER_PART_NO_VALIDATION_STATUS.VALID;
}

export function getCurrentUserCompany() {
    try {
        const user = JSON.parse(localStorage.getItem('user'));
        return user && user.accountId ? user.accountId : '';
    } catch (e) {
        return '';
    }
}
